'use client';

import { useState, useEffect } from 'react';
import { getUsersService } from '@/services/User';
import { getToken } from '@/services/_utils';
import { UserType } from '@/constants/types/models/user/User';
import { useQuery } from '@tanstack/react-query';

// Shared with modules/core/hooks/UseCurrentUser.
export const CURRENT_USER_QUERY_KEY = ['system', 'current_user'];

const useCurrentUser = () => {
  const [currentUser, setCurrentUser] = useState<UserType>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const token = getToken();

  const {
    data: currentUserData,
    isPending,
    refetch: refetchCurrentUser,
  } = useQuery({
    queryKey: [...CURRENT_USER_QUERY_KEY, token?.sub],
    queryFn: ({ signal }) =>
      getUsersService({ cognito_id: token?.sub, signal }),
    // Without a token users/ returns everyone, cached as the current user.
    enabled: !!token,
  });

  useEffect(() => {
    if (currentUserData?.results.length) {
      setCurrentUser(currentUserData.results[0]);
    }
  }, [currentUserData]);

  useEffect(() => {
    setIsLoading(isPending);
  }, [isPending]);

  return {
    currentUser,
    isLoading,
    refetchCurrentUser,
  };
};

export default useCurrentUser;
